import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RisksHttpClient } from '@omnea-app/risks/risksHttpClient'
import { autoFlaggedScoreCategoriesQueryKeys } from './queryKeys'

export const useGetAutoFlaggedScoreCategories = () => {
  const { getToken } = useAuthenticatedUser()
  const { TPRM } = useFeatureFlags()

  return useQuery({
    queryKey: autoFlaggedScoreCategoriesQueryKeys.list(),
    enabled: TPRM,
    queryFn: async () => {
      const risksClient = new RisksHttpClient({ authorization: await getToken() })
      const { data, error } = await risksClient.GET('/auto-flagged-score-categories')
      throwIfApiError(error)
      return data
    },
  })
}
